import React from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { AiOutlineSwapRight } from "react-icons/ai"
import { IconContext } from "react-icons"

import { media } from "../styles/media"
import { brandPagePaths, pagePath } from "../constants/link"

const MenuArrow = () => (
  <IconContext.Provider value={{ color: "#E4D8B9" }}>
    <AiOutlineSwapRight />
  </IconContext.Provider>
)

const StyledMenuList = styled.div`
  background: rgba(102, 49, 0, 0.95);
  box-shadow: -1px 0px 10px black;
  width: 500px;
  height: 100vh;
  position: absolute;
  top: 0;
  right: -500px;
  animation: ${props => {
    if (props.isMenuListActive !== null) {
      if (props.isMenuListActive) {
        return `menu-slide-in 0.3s linear 0s forwards`
      }
      return `menu-slide-out 0.3s linear 0s forwards`
    }
  }};
  z-index: 1000;
  @keyframes menu-slide-in {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-500px);
    }
  }
  @keyframes menu-slide-out {
    from {
      transform: translateX(-500px);
    }
    to {
      transform: translateX(0);
    }
  }
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: center;
  .navLists {
    width: 100%;
    padding: 10px 16px;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    font-size: 1.1em;
    span {
      font-weight: bold;
      color: #663100;
      width: 100%;
    }
    .nonLink {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.colors.light.brown};
    }
    .toLink {
      color: white;
      text-align:center;
      width:100%;
      display:flex;
      flex-flow:row nowrap;
      align-items:center;
      justify-content:center;
      a{
        padding:0;
        margin:0;
      }
    }
    .links {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: space-between;
      width: 90%;
      margin-left: 10%;
      a {
        width: 40%;
        color: white;
      }
    }
    a {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-end;
      justify-content: flex-start;
      margin: 8px 0px 20px;
      svg {
        margin-left: 0.12em;
      }
    }
  }
  ${() =>
    media.sp(css`
      width: 100%;
    `)}
`

const renderPageLink = (path, text) => (
  <Link to={path}>
    {text}
    <MenuArrow />
  </Link>
)

const MenuList = ({ isMenuListActive }) => {
  return (
    <StyledMenuList isMenuListActive={isMenuListActive}>
      <div className="navLists">
        <span className="nonLink">フランソア・ファミリー</span>
        <div className="links">
          {brandPagePaths.map(({ id, path, text }) => (
            <Link to={path} key={id}>
              {text}
              <MenuArrow />
            </Link>
          ))}
        </div>
      </div>

      <div className="navLists">
        <span className="nonLink">商品検索</span>
        <div className="links">
          {renderPageLink(
            pagePath.thisMonthProducts.path,
            pagePath.thisMonthProducts.text
          )}
          {renderPageLink(
            pagePath.productSearch.path,
            pagePath.productSearch.text
          )}
          {/* {renderPageLink(
            pagePath.allergenSearch.path,
            pagePath.allergenSearch.text
          )} */}
        </div>
      </div>

      <div className="navLists">
        <span className="toLink">
          {renderPageLink(pagePath.ourPolicy.path, pagePath.ourPolicy.text)}
        </span>
      </div>

      <div className="navLists">
        <span className="toLink">
          {renderPageLink(pagePath.recipeBook.path, pagePath.recipeBook.text)}
        </span>
      </div>

      <div className="navLists">
        <span className="toLink">
          {renderPageLink(pagePath.cmYoutube.path, pagePath.cmYoutube.text)}
        </span>
      </div>

      <div className="navLists">
        <span className="toLink">
          {renderPageLink(pagePath.inquiry.path, pagePath.inquiry.text)}
        </span>
      </div>
    </StyledMenuList>
  )
}

export default MenuList
